import { useLocation } from "react-router-dom";

/**
 * Triage and reservation each have two routes: a public one and one inside the
 * patient portal, rendering the same screen in a different shell.
 *
 * Links between them have to stay in whichever shell the visitor is already
 * in. Hard-coding the public path meant a signed-in patient who followed
 * "Buat reservasi" from the triage result landed outside the portal, with the
 * sidebar gone and no way back to it.
 */
export function useServiceLink() {
  const { pathname } = useLocation();
  const inPortal = pathname.startsWith("/patient/");
  return (path: string) => (inPortal ? `/patient${path}` : path);
}
